import React, {
  // useEffect,
  useRef,
  useState,
} from "react";
import Modal from "react-bootstrap/Modal";

// import { TableBody, TableRow, TableCell,
//     // InputAdornment
// } from '@mui/material'
// ;
import axios from "axios";
import useTableScroll from "../../useTableScroll";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";

const SeleccionarAlmacen = (props) => {
  let op = require("../../../modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const almacen = JSON.parse(localStorage.getItem("idalmacen"));

  const [values, setValues] = useState({});
  const [itemSelect, setItemSelect] = useState(-1);
  const [select, setSelect] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  // const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  const [activo, setActivo] = useState(true);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const headCells = [
    { label: "CÓDIGO", width: "50px", textAlign: "center" },
    { label: "DESCRIPCIÓN", width: "440px", textAlign: "left" },
  ];
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idalmacen.includes(target.value) ||
              x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const seleccionarAlmacenes = () => {
    setActivate(true);
    let campos = "*";
    let nomtab = "almacen";
    let orden = "idalmacen asc";
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          var clase = [];
          for (let i = 0; i < response.data.length; i++) {
            clase.push({
              idalmacen: response.data[i].idalmacen,
              descripcion: response.data[i].descripcion,
              idorganizacion: response.data[i].idorganizacion,
            });
          }
          setRecords(clase);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const blanquear = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    setItemSelect("");
    setActivate(false);
    setRecords([]);
    setActivo(true);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };
  const cancelar = () => {
    blanquear();
    props.cerrar();
    if (props.onHideCancelar) props.onHideCancelar();
    if (props.setShow) props.setShow(false);
  };

  const cerrarModal = () => {
    if (props.onHideCancelar) {
      props.onHideCancelar();
    }
    if (props.setShow) props.setShow(false);

    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const seleccionarAlmacen = (event) => {
    event.preventDefault();
    var idalmacen = values[0].idalmacen;
    var descrip = values[0].descripcion;

    localStorage.setItem("idalmacen", JSON.stringify(idalmacen));
    localStorage.setItem("almacendes", JSON.stringify(descrip));
    localStorage.setItem("almacebseleccionado", true);

    setMensaje({
      mostrar: true,
      titulo: "Exito.",
      texto: "Almacen Seleccionado Exitosamente.",
      icono: "exito",
    });
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);
    setSelect(parseInt(idalmacen));
    var idalmacen = recordsAfterPagingAndSorting()[index].idalmacen;
    var descripcion = recordsAfterPagingAndSorting()[index].descripcion;
    var idorganizacion = recordsAfterPagingAndSorting()[index].idorganizacion;

    var datos = [];
    datos.push({
      idalmacen,
      descripcion,
      idorganizacion,
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarAlmacenes();
        if (parseInt(almacen) > 0) {
          setSelect(parseInt(almacen));
        } else {
          setSelect(0);
        }
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>Cambio del Ejercicio Fiscal.</h3>
        <a type="button" onClick={cancelar}>
          salir<i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-6 input-group input-group-sm m-0 mb-2 p-0">
          <input
            type="text"
            onChange={handleSearch}
            className="form-control search-input rounded-pill"
          />
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item.idalmacen}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      backgroundColor:
                        select === parseInt(item.idalmacen)
                          ? "lightskyblue"
                          : itemSelect === index
                            ? "lightskyblue"
                            : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "10px",
                      }}
                    >
                      {item.idalmacen}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.descripcion}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer className="footer-azulGradiant">
        <SuccessButton onClick={seleccionarAlmacen} disabled={activo}>
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
};
export default SeleccionarAlmacen;
